// removed by extract-text-webpack-plugin
module.exports = {"mediaQueries":"\"styles/shared/breakpoints.css\"","tPort":"(min-width: 768px) and (max-width: 959px) and (orientation: portrait)","statsTable":"statsTable__statsTable___1OPVm","list":"statsTable__list___1CWv8","statCell":"statsTable__statCell___2Tr4k","label":"statsTable__label___38bhP","value":"statsTable__value___3cUtd","printTitle":"statsTable__printTitle___1_CYc"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/tables/statsTable.css
// module id = 1087
// module chunks = 0